export default __webpack_public_path__ + "static/char-36-a4239b34b391dfbe9eece59b24c355a1.gif";